import { configureStore } from '@reduxjs/toolkit';
import {
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
} from 'react-redux';
import { persistStore } from 'redux-persist';
import persistedRootReducer from './rootReducer';
const store = configureStore({
  reducer: persistedRootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {ignoredActions: ['persist/PERSIST']},
    }),
});

const {dispatch} = store;

const useSelector = useAppSelector;

const useDispatch = () => useAppDispatch();

export { dispatch, useDispatch, useSelector };
export default store;
export const persistor = persistStore(store);
